import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardList, CardError, Loading } from '../../components';
import { getDoctors } from '../../redux/actions/doctorActions';

const DoctorsScreen = () => {
  const dispatch = useDispatch();
  const { doctors, isLoading } = useSelector((state) => state.doctorReducer);
  useEffect(() => {
    dispatch(getDoctors());
  }, []);

  if (isLoading) return <Loading />;

  if (doctors?.length === 0) {
    return <CardError text="No hay medicos disponibles" />;
  }

  return (
    <div style={{ paddingBottom: 15 }}>
      <CardList data={doctors} type="doctor" title="Elija un médico" />
    </div>
  );
};

export default DoctorsScreen;
